<template>
  <CollapsibleSection
    class="pb-0"
    title-data-ec="bulk_send_review_data_page_valid_contacts"
  >
    <template v-slot:title>
      <CheckIcon class="text-white bg-success3 rounded-full h-base w-base p-xs mr-sm flex-shrink-0" />
      <ValidBulkSendRowsTitle
        :total-count="bulkSend.imported_rows_count"
        :valid-count="meta.total"
      />
    </template>
    <template v-slot:content>
      <DataTable
        :rows="validComputedRows"
        :columns="validComputedColumns"
        class="mb-twenty"
      />
      <NumberedPaginator
        v-if="meta !== null && meta.last_page > 1"
        :meta="meta"
        :resource="$t('bulkSend.steps.reviewData.validRowPagination')"
        @page="$emit('page', $event)"
        page-data-ec="bulk_send_review_data_page_valid_contacts"
      />
    </template>
  </CollapsibleSection>
</template>

<script>
import NumberedPaginator from '@/components/ui/pagination/Paginator.vue';
import DataTable from '@/components/library/dataTables/DataTable.vue';
import CollapsibleSection from '@/components/library/sections/CollapsibleSection.vue';
import ValidBulkSendRowsTitle from '@/components/ui/bulkSend/reviewData/ValidBulkSendRowsTitle.vue';
import { mapGetters } from 'vuex';
import { CheckIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ValidBulkSendRows',
  components: {
    ValidBulkSendRowsTitle,
    CollapsibleSection,
    DataTable,
    NumberedPaginator,
    CheckIcon,
  },
  props: {
    meta: {
      type: Object,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      bulkSend: 'bulkSend/bulkSend',
    }),
    errorColumnIndex() {
      return this.meta.headings.findIndex(heading => heading.field === 'error_count');
    },
    validComputedColumns() {
      return this.meta.headings
        .filter(heading => heading.field !== 'error_count')
        .map(heading => heading.title);
    },
    validComputedRows() {
      return this.results.map((row) => {
        // Remove the error column from the results
        row.splice(this.errorColumnIndex, 1);

        return row.map(columnValue => (typeof columnValue === 'object' ? columnValue.value : columnValue));
      });
    },
  },
};
</script>

<style scoped>

</style>
